import React, { useState, useCallback, useRef, useEffect, createContext, useContext } from 'react';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timerIds = useRef({});

  // Clear all timers on unmount
  useEffect(() => {
    return () => {
      Object.values(timerIds.current).forEach(clearTimeout);
    };
  }, []);

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    const timerId = setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
      delete timerIds.current[id];
    }, 4000);
    timerIds.current[id] = timerId;
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      {/* A live region, so a toast is announced as well as shown. */}
      <div className="toast-container" role="status" aria-live="polite">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type}`}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
